export const PORTAL_ADDRESS_VISIBILITY_FLAG = 'portal_address_visibility';
export const ADDRESS_VISIBILITY_CONFIG_KEY = 'H';
export const LISTING_ADDRESS_VALUE = 0;

export const LEVEL_LABEL_BY_VALUE = {
  1: 'AddressVisibilityNeighborhood',
  2: 'AddressVisibilityStreet',
  3: 'AddressVisibilityStreetAndNumber',
  4: 'AddressVisibilityRealAddress',
};

export const EXAMPLE_BY_VALUE = {
  1: 'NeighborhoodExample',
  2: 'StreetExample',
  3: 'StreetAndNumberExample',
  4: 'RealAddressExample',
};
